import styled from 'styled-components';

const ResolutionWrapper = styled.div`
  .ant-form-item {
    margin-bottom: 0;
  }
`;

export default ResolutionWrapper;
